import {styled} from "@mui/material/styles"
import {Typography, Toolbar, Modal, Button} from "@mui/material"

export const ModalTitle = styled(Typography)<{component: "h1"}>`
    flex-grow: 1;
    text-transform: uppercase;
    letter-spacing: 0.0625rem;
`

export const ModalAppBar = styled("div")``

export const ModalToolbar = styled(Toolbar)`
    border-bottom: ${props => props.theme.colours.drawer.headerBorder};
    background-color: ${props => props.theme.colours.drawer.headerBackground};
    padding: 1rem;
    height: 2.75rem;

    & > button {
        float: right;
        padding: 0;
        text-align: right;
        display: block;
    }
`

export const StyledModal = styled(Modal)`
    display: flex;
    align-items: center;
    justify-content: center;
`

export const FiltersBody = styled("div")`
    display: flex;
`

export const FiltersReview = styled("div")`
    display: flex;
    flex-direction: column;
`

export const ModalBody = styled("div")`
    background-color: white;
    width: 43.75rem;
    outline: none;
    border-radius: 0;
    z-index: 1;
`

export const ConfirmCTAOuterWrapper = styled("div")`
    display: flex;
    justify-content: flex-end;
    padding: 0.5rem 1rem;
`

export const StyledCTA = styled(Button)`
    && {
        height: 2.25rem;
        width: 8.25rem;
        background: ${({theme}) => theme.colours.form.buttonPrimary.background};
        border: ${({theme}) => theme.colours.form.buttonPrimary.border};
        color: ${({theme}) => theme.colours.form.buttonPrimary.color};
        border-radius: ${({theme}) => theme.colours.form.buttonTertiary.radius};
        font-family: ${({theme}) =>
            `${theme.colours.component.buttonMedium.fontFamily}, ${theme.colours.font.default}`};
        font-weight: ${({theme}) => theme.colours.component.buttonMedium.fontWeight};
        font-size: ${({theme}) => theme.colours.component.buttonMedium.fontSize};
        text-transform: ${({theme}) => theme.colours.component.buttonMedium.textTransform};
        letter-spacing: ${({theme}) => theme.colours.component.buttonMedium.letterSpacing};
        line-height: ${({theme}) => theme.colours.component.buttonMedium.lineHeight};
    }
`
